<template>
  <div class="other-query">
    <div class="date-box">
        <div v-if="loadingData.dateLoading" class="loading el-icon-loading"/>
        <el-date-picker
            :value="otherQueryParams.range_time"
            :disabled="loadingData.dateLoading"
            style="width: 220px;"
            popper-class="other-query-popper"
            type="daterange"
            align="left"
            value-format="yyyy-MM-dd"
            :editable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            size="mini"
            ref="pickerRef"
            @focus="handleDateFocus"
            @blur="handleDateBlur"
            @input="(value)=>updataOtherQueryParams('range_time', value)"
            :picker-options="pickerOptions">
        </el-date-picker>
    </div>
    <el-popover
        placement="bottom-end"
        width="520"
        trigger="hover">
        <div slot="reference" class="text-color-primary inline-block pointer">
            <span class="">更多配置</span>
            <span  class="el-icon-setting pointer-icon ver-middle"></span>
        </div>
        <el-form label-width="120px">
            <el-form-item label="素材显示范围：">
                <el-switch 
                    :value="otherQueryParams.default_display_range" 
                    active-value="1" 
                    inactive-value="0"
                    @input="(value)=>updataOtherQueryParams('default_display_range', value)"
                />
                <p class="text-color-gray font12px mt6">开启后，所选数据期间段内无消耗的素材不会展示在查询结果中</p>
            </el-form-item>
            <el-form-item label="维度默认排序：">
                <el-switch 
                    :value="otherQueryParams.dimension_default_sort" 
                    active-value="1" 
                    inactive-value="0"
                    @input="(value)=>updataOtherQueryParams('dimension_default_sort', value)"
                />
                <p class="text-color-gray font12px mt6">开启后，查询结果的前{{ DEFAULT_DIMENSION_SORT_NUM }}个维度将按照选择的第一个指标默认降序（手动设置的除外）</p>
            </el-form-item>
        </el-form>
    </el-popover>
  </div>
</template>

<script>
import dateShortcuts, { getDateShortcuts } from '../../dateShortcuts.js';
import dayjs from 'dayjs';
import { DEFAULT_DIMENSION_SORT_NUM } from '../../constant'
let POPPER_DOM = null;
// defaultDisabledDate
export default {
    props: [ 'otherQueryParams' ],
    inject: [ 'updataOtherQueryParams', 'getDisableDate', 'loadingData', 'global' ],
    data() {
        const date = new Date();
        const _this = this;
        return {
            DEFAULT_DIMENSION_SORT_NUM,
            allDisabledDate: [],//日期禁用列表
            pickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    // dateShortcuts.today,
                    ...getDateShortcuts(_this),
                    {
                        name:'all',
                        // text: '选中所有有数据日期',
                        text: '所有数据日期',
                        async onClick(picker) {
                            const params = {
                                quick_date: '所有有数据日期'
                            }
                            const { all_disabled, end_date, start_date, has_cost_date } = await _this.getDisableDate(params);
                            if (all_disabled) {
                                _this.$message.error('所选筛选在该日期无任何数据');
                            };
                            _this.allDisabledDate = has_cost_date;
                            picker.$emit('pick', [_this.formatDate(start_date), _this.formatDate(end_date)], undefined, '所有数据日期');
                        }
                    },
                ],
                disabledDate(time) {
                    // 所选筛选条件在该日期无任何数据
                    return _this.isDisabledDate(time) || !_this.validateSingleAuthDate(time)
                },
                cellClassName(date) {
                    if (_this.isDisabledDate(date)) {
                        return 'disabled-date custom-disabled'
                    }else {
                        if (!_this.validateSingleAuthDate(date)) {
                            return 'auth-date custom-disabled'
                        }
                    }
                },
            },
            picker: null,
        }
    },
    computed: {
        disabledDate() {
            if (this.allDisabledDate.length) {
                return this.allDisabledDate
            }else {
                return this.global.defaultDisabledDate.has_cost_date;
            }
        },
        disabledDateData() {
            return this.disabledDate.reduce((pre, item)=> {
                pre[this.formatDate(item)] = true;
                return pre;
            }, {})
        },
        authDate() {
            const dataDays = this.global.dataDays;
            if (+dataDays === -1) {
                return true
            }else {
                const datejs = dayjs();
                return Array.from({length: +dataDays}).map((_, i)=> {
                    return this.formatDate(datejs.subtract(i, 'day'))
                })
            };
        }
    },
    mounted() {
        const fn = ()=> {
            this.allDisabledDate = []
        };
        this.$bus.$on('resetDisableDate', fn);
        this.$once('hook:beforeDestroy', () => {
        this.$bus.$off('resetDisableDate', fn)
    });
    },
    methods: {
        async beforePicker(dateList) {
            if (!this.validateAuthDate(dateList)) {
                this.$message.error('所选筛选在该日期无任何数据');
                return Promise.reject()
            }
        },
        validateSingleAuthDate(date) {
            if (typeof this.authDate === 'boolean') {
                return true
            }else {
                if (!this.authDate.length) {
                    return false
                };
                const endDate = this.authDate[0];
                const  startDate = this.authDate[this.authDate.length - 1];
                const time = dayjs(this.formatDate(date)).valueOf();
                return time >=  dayjs(startDate).valueOf() && time <= dayjs(endDate).valueOf()
            }
        },
        validateAuthDate( dateList ) {
            const [startDate, endDate] = dateList.map(date=>dayjs(this.formatDate(date)).valueOf());
            if (typeof this.authDate === 'boolean') {
                const has_cost_date = this.global.defaultDisabledDate.has_cost_date;
                const hasDate = has_cost_date.some(date=> {
                    const time = dayjs(date).valueOf();
                    return time>= startDate && endDate >= time
                });
                return hasDate;
            }else {
                const hasDate = this.authDate.some(date=> {
                    const time = dayjs(date).valueOf()
                    return time>= startDate && endDate >= time;
                });
                return hasDate;
            }
        },
        isDisabledDate(time) {
            // // 大于今日
            // if (new Date(time).getTime() > new Date().getTime() -  3600 * 1000 * 24) {
            //     return true;
            // };
            // 小于起始日期
            const startDate = this.global.startDate;
            if (startDate && new Date(time).getTime() < new Date(this.formatDate(startDate) ).getTime()) {
                return true
            };
            // 所有数据日期
            if (!this.disabledDate.length) {
                return false;
            }
            const currentTime = this.formatDate(time);
            if (!this.disabledDateData[currentTime]) {
                return true;
            }
            return false
        },
        // 添加无数据提示
        addNoDataTip(e) {
            const dom = e.target;
            [dom, dom.parentElement, dom.parentElement.parentElement]
            .map(dom=> {
                if (dom.classList.contains('disabled-date')) {
                    dom.setAttribute('title', '所选筛选条件在该日期无任何数据');
                    return
                };
                if (dom.classList.contains('auth-date')) {
                    dom.setAttribute('title', `当前权限仅可查询近${this.global.dataDays}天数据,若需查询该日请向上级领导申请`);
                    return
                }
            })
        },
        // 获取焦点
        handleDateFocus() {
            this.$nextTick(()=> {
                const popperDom = POPPER_DOM = document.querySelector('.other-query-popper');
                const disDom = popperDom.querySelectorAll('.custom-disabled');
                disDom.forEach(dom=> {
                    dom.removeAttribute('title')
                });
                popperDom.addEventListener("mousemove" ,this.addNoDataTip);
                if (!this.picker) {
                    const picker = this.$refs.pickerRef.picker;
                    this.picker = picker;
                }
            })
        },
        // 失去焦点
        handleDateBlur() {
            POPPER_DOM.removeEventListener("mousemove", this.addNoDataTip)
        },
        // 格式化日期
        formatDate(date) {
            return dayjs(date).format('YYYY-MM-DD')
        }
    },
    watch: {
        picker(picker) {
            if (picker) {
                picker.$on('pick', (date, visible, quick_date="")=> {
                    const [ start, end ] = date || [];
                    const defaultStartDate =  this.formatDate(this.global.startDate);
                    // 判断是否为有效日期
                    if (
                        new Date(end).getTime() >= new Date(defaultStartDate).getTime()
                    ) {//有效
                        this.updataOtherQueryParams('quick_date', quick_date)
                    }else {
                        this.$message.error('所选筛选在该日期无任何数据');
                    }
                })
            }
        }
    }
}
</script>
<style>
.other-query-popper {
    min-height: 350px;
}
</style>
<style lang="scss" scoped>
.other-query {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    .date-box {
        position: relative;
        .loading {
            position: absolute;
            height: 20px;
            width: 20px;
            right: 8px;
            z-index: 2;
            font-size: 20px;
            top: 4px;
            color: #ccc;
        }
    }
    .ver-middle {
        line-height: 28px;
        vertical-align: middle;
        margin: 0 6px;
    }
    .pointer-icon{
        font-size: 18px;
        vertical-align: -3px;
    }
}

</style>